{
  "progress": {
    "done": "Completed",
    "step": "Step {{current}} of {{total}}"
  },
  "intro": {
    "tag": "Your opinion matters",
    "defaultDescription": "Answer a few quick questions and help us improve your experience.",
    "questions_one": "{{count}} question",
    "questions_zero": "{{count}} questions",
    "questions_other": "{{count}} questions",
    "duration": "~{{minutes}} min",
    "start": "Start now",
    "later": "Answer later"
  },
  "navigation": {
    "previous": "Previous",
    "submit": "Submit answer",
    "next": "Next"
  },
  "done": {
    "title": "Thank you!",
    "description": "Your answer was submitted successfully",
    "xpEarned": "+{{xp}} XP earned"
  },
  "input": {
    "selectPlaceholder": "Select",
    "npsLow": "Not at all likely",
    "npsHigh": "Extremely likely"
  },
  "toast": {
    "created": "Survey created!",
    "createError": "Error creating survey",
    "updated": "Survey updated!",
    "updateError": "Error updating survey",
    "deleted": "Survey deleted",
    "deleteError": "Error deleting",
    "duplicated": "Survey duplicated!",
    "duplicateError": "Error duplicating",
    "responseSent": "Answer submitted successfully!",
    "responseError": "Error submitting answer"
  }
}
